<template>
  <div class="section-sources">
    <component-loader :progress="90" v-if="showLoader" :unlimitedProgress="true"></component-loader>
    <vs-row class="sources-main">
      <vs-col vs-justify="center" vs-align="center" vs-w="12">
        <div class="table-title">
          <p>{{$t('dash.sources.title')}}</p>
        </div>
        <p class="subtitle">{{$t('dash.sources.subtitle')}}</p>

        <Tooltip v-if="checkLock('sources') || checkLock('partner')" :text="$t('dash.locked')" position="top">
          <vs-button
            class="btn-img btn-large"
            color="#2F1937"
            size="large"
            @click="addNewSource()"
            vs-type="filled"
            disabled
          >
            <p>{{$t('dash.sources.add')}}</p>
            <img class="icon-white" src="../../../assets/img/tabs/ico-sources.svg" alt="rss">
          </vs-button>
          <span>&nbsp;</span>
        </Tooltip>
        <vs-button
          v-if="checkLock('sources') || checkLock('partner')"
          @click="goToSettings()"
          class="btn-large btn-img"
          color="#2F1937"
          vs-type="filled"
        >
          <p>{{$t('dash.button.changeplan')}}</p>
          <img src="../../../assets/img/icon_unlock.svg" alt="unlock">
        </vs-button>
        <vs-button
          v-if="!checkLock('sources') && !checkLock('partner')"
          class="btn-img btn-large"
          color="#2F1937"
          size="large"
          @click="addNewSource()"
          vs-type="filled"
        >
          <p>{{$t('dash.sources.add')}}</p>
          <img class="icon-white" src="../../../assets/img/tabs/ico-sources.svg" alt="rss">
        </vs-button>

        <div class="search-page">
          <vs-input
            @keypress.enter.prevent
            v-model="sourceFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.settings.user.label.source_filter')"
          />
        </div>

        <div v-if="!!sourceList.length" class="sources-tables">
          <div class="sources-wrapper">
            <component-table
              :gridData="sourceListReverse"
              :columns="customColumns"
              v-on:edit="edit"
              v-on:openUpdateBots="openUpdateBots"
              v-on:goToBot="goToBot"
              v-on:remove="removeSource"
              v-on:addToBot="addToBot"
              v-on:confirmEnable="confirmEnable"
              :name="'custom-sources'"
            ></component-table>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <vs-popup class="overlay sources-overlay" title="Source" :active.sync="add">
      <component-sources-overlay
        :mode="mode"
        :editSource="editSource.id"
        @close-source-form="cleanData"
        @fetchSources="fetchSources"
      >
      </component-sources-overlay>
    </vs-popup>

      <vs-popup class="overlay groups source-to-pages" 
                :title="$t('dash.source.affected-to-pages', { name: sourceSelected ? sourceSelected.name : '' })" 
                :active.sync="popupSourceToPages">
                
        <component-pages-selector
          :noName="true"
          :groups="groups"
          :pagesAdded="pagesAdded"
          :type="'source_to_page'"
          v-on:submit="updateBots"
          v-if="popupSourceToPages"
        ></component-pages-selector>

      </vs-popup>

    <vs-popup :title="dialog.title" :active.sync="dialog.show">
      <p>{{dialog.message}}</p>
    </vs-popup>
  </div>
</template>

<script>
import componentTable from './../Table.vue'
import componentSourcesOverlay from './../overlay/Sources.vue'
import Sources from '../../mixins/Sources'
import Upgradable from '../../mixins/Upgradable'
import User from '../../mixins/User'
import Groups from '../../mixins/Groups'
import Bots from '../../mixins/Bots'
import Common from '../../mixins/Common'
import Notif from '../../mixins/Notif'
import componentLoader from './../overlay/Loader.vue'
import componentPagesSelector from './../overlay/PagesSelector.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
  name: 'component-sources',

  components: {
    componentTable,
    componentSourcesOverlay,
    componentLoader,
    componentPagesSelector,
    Tooltip
  },

  mixins: [Sources, Groups, Bots, Upgradable, User, Common, Notif],

  beforeMount(){
    this.$ga.page(this.$router)
  },

  async mounted() {
    localStorage.setItem('section', 'sources')
    this.fetchGroups()
    new Promise(async (resolve, reject) => {
      await this.fetchBots()
      resolve()
    })
    .then(this.fetchSources)
    // Show dialog if requested via router
    if (this.$route.params.showDialog) {
      // This feels more natural when delayed a bit
      setTimeout(() => this.add = true, 500)
    }
  },

  computed: {
    sourceListReverse() {
      return this.sourceList.slice().reverse().filter(source => this.checkSourceFilter(source))
    }
  },

  methods: {

    checkSourceFilter(source){
      if(!source) return false
      return source.name.toLowerCase().includes(this.sourceFilter.toLowerCase()) 
                || source.url.toLowerCase().includes(this.sourceFilter.toLowerCase())
                || source.pages.find(p => p.page.name.toLowerCase().includes(this.sourceFilter.toLowerCase()) || p.page.network.toLowerCase().includes(this.sourceFilter.toLowerCase()))
    },

    addNewSource(){
      this.add = true
      this.mode = 'new'
    },

    /*
     * Delete source
     */
    removeSource(id) {
      let source = JSON.parse(localStorage.sources).find(s => s.id == id)
      let bot = localStorage.bots && JSON.parse(localStorage.bots) ? JSON.parse(localStorage.bots).find(b => b.flux.includes(source.uid)) : null
      if(bot){
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: this.$t('dash.sources.confirm.delete.title'),
          text: this.$t('dash.sources.confirm.delete.text'),
          acceptText: "OK",
          accept: () => this.acceptDelete(id)
        })
      }
      else {
        this.acceptDelete(id)
      }
    },

    acceptDelete(id) {
      this.showLoader = true
      this.deleteSource(id).then(res => {
        this.showLoader = false
        const { success } = res.body

        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }

        this.fetchSources()
        this.cleanData()
        this.showLoader = false
      })
    },

    /*
     * Add source to bots
     */
    addToBot(id) {
      localStorage.setItem('section', 'bots')
      this.$router.push({
        name: 'bots',
        params: {
          source: id
        }
      })
    },

    confirmEnable(id){
      let source = this.sourceList.find(s => s.id == id)
      let body = {
        name: source.name,
        url: source.url,
        id: id
      }

      this.showLoader = true
      this.putSource(body).then(res => {
        this.showLoader = false
        const { success, source } = res.body

        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }

        this.$vs.notify({
          time: 10000,
          title: this.$t('dash.notifications.success_title'),
          text: this.$t('dash.notifications.source_enabled'),
          color: 'primary'
        })

        let index = this.sourceList.findIndex(s => s.id == id)
        this.sourceList[index].status = true
      })
    },

    /*
     * Edit source
     */
    edit(id) {
      // Check user can edit sources
      if (!this.checkLock('source_choice')) {
        this.notifyNotPremium()
        return
      }

      this.editSource.id = id
      this.mode = 'edit'
      this.add = true
    },

    cleanData() {
      this.edit.id = ''
      this.mode = 'new'
      this.add = false
    },

    /**
     * Get sources
     */
    async fetchSources() {
      this.showLoader = true
      await this.listSources({section: true}).then(res => {
        this.showLoader = false
        const { success, sources } = res.body
        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }
        localStorage.setItem('sources', JSON.stringify(sources))
        this.sourceList = [...sources.map(source => {
          return { 
            ...source, 
            pages: this.bots.filter(b => b.flux.includes(source.uid))
          }
        })]
        localStorage.setItem('sources', JSON.stringify(this.sourceList))
      })
    },

    
    goToBot: function(bot) {
      // document.querySelector(`.vs-tooltip`).remove()
      localStorage.setItem('section', 'bots')
      this.$router.push({
        name: 'bots',
        params: {
          bot: bot
        }
      })
    },

    openUpdateBots(source) {
      this.sourceSelected = source
      this.popupSourceToPages = true
      
      let bots = localStorage.bots && JSON.parse(localStorage.bots) ? JSON.parse(localStorage.bots) : []
      if(bots.length)
        this.pagesAdded = [...new Set(bots.filter(b => b.flux.includes(source.uid)).map(b => b.page))]
        
    },

    async updateBots(form) {
      this.popupSourceToPages = false
      this.showLoader = true
      let pages = form.pages.filter(pageId => !this.pagesAdded.find(p => p.id == pageId))
      let bots = this.bots.filter(b => pages.includes(b.page.id) && b.service == "dashboard")
                  .sort((a, b) => {
                    if (a.flux.length > b.flux.length )
                      return -1;
                    if (a.flux.length < b.flux.length)
                      return 1;
                    return 0;
                  })
      let botsToEdit = []
      for(let b of bots) {
        //add flux
        if(!botsToEdit.find(bEdit => bEdit.page == b.page.id)){
          delete b.sources
          delete b.expires_at
          botsToEdit.push({ ...b, page: b.page.id, flux: [ ...b.flux, this.sourceSelected.uid ]})
          localStorage.setItem('last_selected_page', JSON.stringify(b.page))
          localStorage.setItem('last_selected_pages', JSON.stringify([b.page]))
        }
      }
      //remove flux
      for(let page of this.pagesAdded.filter(p => !form.pages.includes(p.id))) {
        if(!form.pages.find(p => page.id == p.id)){
          let botsRemoveFlux = this.bots.filter(b => b.service == "dashboard" && b.page.id == page.id && b.flux.includes(this.sourceSelected.uid))
          for(let b of botsRemoveFlux) {
            delete b.sources
            delete b.expires_at
            botsToEdit.push({ ...b, page: b.page.id, flux: b.flux.filter(f => f != this.sourceSelected.uid), frequency: b.flux.filter(f => f != this.sourceSelected.uid).length ? b.frequency : 0})
          }
        }
      }
      this.pagesAdded = []

      Promise.all(botsToEdit.map(async (body) => {
        // delete body.sources
        const res = await this.modifyBot(body)
        const { success, bot, code } = res.body
  
        if (!success || success !== true) {
          const { code } = res.body.error
                ? res.body.error
                : res.body.reason;
          const errBody = code
            ? `dash.notifications.${code}`
            : 'dash.bots.error.description'
  
          console.log(code, errBody, this.$t(errBody))
          this.notify({
            title: this.$t('dash.bots.error.title'),
            text: this.$t(errBody),
            color: 'primary',
            id: 'norepeat'
          }, {
            component: "Sources",
            action: "modifyBot",
            params: {
              ...body
            }
          })
          return
        }
      }))
      .then(this.fetchBots)
      .then(this.fetchSources)
      .then(() => {
        this.showLoader = false
        this.$vs.notify({
          color: 'primary',
          title: this.$t('dash.notifications.success_title'),
          text: this.$t('dash.bots.success.updated_description')
        })
      })
    },

    async fetchGroups() {
      if(localStorage.groups) this.groups = JSON.parse(localStorage.groups)
      // let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      await this.getGroups().then(res => {
        this.groups = res.map(group => {
          return {...group, show: true}
          // return {...group, show: !hideGroups.find(g => g == group.id)}
        })
      })
      localStorage.groups = JSON.stringify(this.groups)
    },

    /**
     * Retrieve bots from database and cache them.
     */
    async fetchBots() {
      try {
        // Get bot list from server
        const { body, statusText } = await this.getAllBots({}, true)
        const { success, bots } = body
        if (!success) {
          throw Error(statusText)
        }
      
        // Initiate the sources prop on each bot. Normal bots should have an empty array in sources
        bots.map(b => b.sources = this.sourceList.filter(s => b.flux.includes(s.uid)))
        this.bots = bots
        localStorage.setItem('bots', JSON.stringify(bots))

      } catch (err) {
        console.log(err)
        return this.handleError(err)
      }
    },
  },

  data() {
    return {
      add: false,
      mode: 'new',

      dialog: {
        show: false,
        title: 'Bots',
        message: null
      },

      sourceList: [],

      editSource: {
        id: ''
      },

      // Custom Sources table
      customColumns: ['name', 'pages', 'status', 'actions'],

      gridColumns1: ['name', 'url', 'actions'],
      gridData1: [
        {
          name: 'Fan St-Etienne',
          url: 'https://avatars2.githubusercontent.com/',
          analytics: 'GA-XXX-XXX-XXX'
        },
        {
          name: 'Fan St-Etienne',
          url: 'https://avatars2.githubusercontent.com/u/31676496?s=460&v=4',
          analytics: 'GA-XXX-XXX-XXX'
        },
        {
          name: 'Fan St-Etienne',
          url: 'https://avatars2.githubusercontent.com/u/31676496?s=460&v=4',
          analytics: 'GA-XXX-XXX-XXX'
        },
        {
          name: 'Fan St-Etienne',
          url: 'https://avatars2.githubusercontent.com/u/31676496?s=460&v=4',
          analytics: 'GA-XXX-XXX-XXX'
        }
      ],
      showLoader: false,

      popupSourceToPages: false,
      sourceSelected: null,
      groups: null,
      pagesAdded: [],
      bots: [],
      sourceFilter: ''
    }
  }
}
</script>
